import React, { useState } from 'react';
import Sidebar from '../../components/Sidebar';
import TabSelector from '../../components/TabSelector';
import BidReviewScreen from '../../screens/Supplier/BidReviewScreen';
import BidSubmitScreen from '../../screens/Supplier/BidSubmitScreen';

const SupplierReviewPage = () => {
  const [currentTab, setCurrentTab] = useState('review_quote');
  const options = [
    { id: 'review_quote', label: 'Review' },
    { id: 'submit_bid_quote', label: 'Submit Bid' },
  ];

  const handleTabChange = (tab) => {
    setCurrentTab(tab);
  };

  const getCurrentSection = () => {
    if (currentTab === 'review_quote') {
      return <BidReviewScreen handleTabChange={handleTabChange} />;
    } else if (currentTab === 'submit_bid_quote') {
      return <BidSubmitScreen handleTabChange={handleTabChange} />;
    }
  };

  return (
    <div className="flex flex-row">
      <div className="self-stretch">
        <Sidebar />
      </div>

      <div className="flex flex-col flex-grow px-10 max-w-screen">
        <TabSelector
          options={options}
          handleTabChange={handleTabChange}
          currentTab={currentTab}
        />

        <div className="">{getCurrentSection()}</div>
      </div>
    </div>
  );
};

export default SupplierReviewPage;
